import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Book from "../components/Book/Book";
import BusinessContextProvider from "../context/business";
import Success from "../components/Success/Success";

export default function Routes() {
  return (
    <BrowserRouter basename="/book-business">
      <Switch>
        <Route
          path="/:businessID/success"
          component={() => (
            <BusinessContextProvider>
              <Success />
            </BusinessContextProvider>
          )}
        />
        <Route
          path="/:businessID/:categoryID"
          component={() => (
            <BusinessContextProvider>
              <Book />
            </BusinessContextProvider>
          )}
        />
        <Route
          path="/:businessID"
          component={() => (
            <BusinessContextProvider>
              <Book />
            </BusinessContextProvider>
          )}
        />
      </Switch>
    </BrowserRouter>
  );
}
